import { InfoOutlined } from '@mui/icons-material';
import { FormHelperText, Stack } from '@mui/material';
import { Text, TextProps } from '@vestwell-frontend/ui';

import { FormikProps } from 'formik';
import React from 'react';

import { FormikPropsWithServerError } from '../helpers/formValidationHelper';

export type FormServerErrorProps<T> = {
  formikRef: React.RefObject<FormikProps<T>>;
} & TextProps;

export const FormServerError = <T extends FormikPropsWithServerError>({
  mb = 4,
  variant = 'g1',
  formikRef: formikRef
}: FormServerErrorProps<T>) => {
  return (
    <>
      {formikRef?.current?.errors?.server && (
        <FormHelperText
          aria-atomic='true'
          data-component='textFieldError'
          data-testid='serverError'
          role='alert'>
          <Stack alignItems='center' direction='row' gap={1} mb={mb}>
            <InfoOutlined color='error' fontSize='small' />
            <Text
              color='error'
              dangerouslySetInnerHTML={{
                __html: formikRef.current.errors.server
              }}
              mb={0}
              variant={variant}
            />
          </Stack>
        </FormHelperText>
      )}
    </>
  );
};
